<template>
    <b-card class="mt-3">
        <b-form class="mt-3">
            <div>
                <b-row>
                    <b-col md="6" cols="12" class="dd">
                        <label for="input-section-section" class="mb-3"
                            ><strong>{{
                                $translate('section_to_section')
                            }}</strong></label
                        >
                        <b-form-select
                            class="form-control"
                            id="input-section-section"
                            v-model="model_order_types.sectionSection"
                            :options="
                                getSpecifiedOrderTypes(
                                    'Internal',
                                    'Outbound',
                                    'Internal'
                                )
                            "
                            text-field="name"
                            value-field="id"
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    {{ $translate('section_to_section_transfer') }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col md="6" cols="12" class="dd mt-3 mt-md-0">
                        <label for="input--section-officer" class="mb-3"
                            ><strong>{{
                                $translate('section_to_officer')
                            }}</strong></label
                        >

                        <b-form-select
                            class="form-control"
                            id="input--section-officer"
                            v-model="model_order_types.sectionOfficer"
                            :options="
                                getSpecifiedOrderTypes(
                                    'Officer',
                                    'Outbound',
                                    'Internal'
                                )
                            "
                            text-field="name"
                            value-field="id"
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    {{ $translate('section_to_officer_transfer') }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col md="6" cols="12" class="dd mt-3">
                        <label for="input--section-loss-vault" class="mb-3"
                            ><strong>{{
                                $translate('section_inventory_adjustment')
                            }}</strong></label
                        >
                        <b-form-select
                            class="form-control"
                            id="input--section-loss-vault"
                            v-model="model_order_types.sectionLoss"
                            :options="
                                getSpecifiedOrderTypes(
                                    'Internal',
                                    'Inbound',
                                    'Black Hole'
                                )
                            "
                            text-field="name"
                            value-field="id"
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    {{
                                        $translate(
                                            'select_section_inventory_adjustment'
                                        )
                                    }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col md="6" cols="12" class="dd mt-3">
                        <label for="input--officer-loss-vault" class="mb-3"
                            ><strong>{{
                                $translate('officer_inventory_adjustment')
                            }}</strong></label
                        >
                        <b-form-select
                            class="form-control"
                            id="input--officer-loss-vault"
                            v-model="model_order_types.officerLoss"
                            :options="
                                getSpecifiedOrderTypes(
                                    'Officer',
                                    'Inbound',
                                    'Black Hole'
                                )
                            "
                            text-field="name"
                            value-field="id"
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    {{
                                        $translate(
                                            'select_officer_inventory_adjustment'
                                        )
                                    }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col md="6" cols="12" class="dd mt-3">
                        <label for="input--officer-section" class="mb-3"
                            ><strong>{{
                                $translate('officer_to_section')
                            }}</strong></label
                        >
                        <b-form-select
                            class="form-control"
                            id="input--officer-section"
                            v-model="model_order_types.officerSection"
                            :options="
                                getSpecifiedOrderTypes(
                                    'Officer',
                                    'Inbound',
                                    'Internal'
                                )
                            "
                            text-field="name"
                            value-field="id"
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    {{ $translate('officer_to_section_transfer') }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col md="6" cols="12" class="dd mt-3">
                        <label for="input--loss-section" class="mb-3"
                            ><strong>{{
                                $translate('external_sourcing')
                            }}</strong></label
                        >
                        <b-form-select
                            class="form-control"
                            id="input--loss-section"
                            v-model="model_order_types.lossSection"
                            :options="
                                getSpecifiedOrderTypes(
                                    'Internal',
                                    'Outbound',
                                    'Black Hole'
                                )
                            "
                            text-field="name"
                            value-field="id"
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    {{ $translate('select_external_sourcing') }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row class="mt-4">
                    <b-col class="text-center">
                        <b-button id="update-settings-btn" variant="blue-button" @click="$emit('update')">{{
                            $translate('update')
                        }}</b-button>
                    </b-col>
                </b-row>
            </div>
        </b-form>
    </b-card>
</template>



<script>
export default {
    name: 'inventoryTransfer-transferSettings',
    data() {
        return {
            modalVisible: false,
        }
    },
    props: ['getSpecifiedOrderTypes', 'transferOrderTypes'],
    methods: {
        showModal() {
            this.modalVisible = true
        },
        hideModal() {
            this.modalVisible = false
        },
    },
    computed: {
        isOK() {
            const {
                sectionSection,
                sectionOfficer,
                sectionLoss,
                officerLoss,
                officerSection,
                lossSection,
            } = this.model_order_types
            return !!(
                sectionSection &&
                sectionOfficer &&
                sectionLoss &&
                officerLoss &&
                officerSection &&
                lossSection
            )
        },
        model_order_types: {
            get: function () {
                return this.transferOrderTypes || {}
            },
            set: function (newValue) {
                this.$emit('update-order-types', newValue)
            },
        },
    },
}
</script>